<template>
  <div class="section center-vertical" id="n1Section">
    <div class="section center-vertical">
      <p class="mt-5 text text-justify" data-aos="fade-down">
        <br />
        / / /
        <br />
        <br />
        O Infovírus - Pandemia e Prisões foi criado em abril de 2020 a partir da iniciativa de pesquisadores/as autônomos e dos seguintes Grupos de Pesquisa: Centro de Estudos em Desigualdade e Discriminação (CEDD/UnB), Grupo Asa Branca de Criminologia (UFPE, UNICAP), Grupo de Pesquisa em Criminologia (UEFS,UNEB), Grupo de Pesquisa Poder, Controle e Dano Social (UFSC). O objetivo do projeto é disseminar dados, informações e análises acerca da situação da pandemia no sistema prisional brasileiro colaborando com o aprimoramento do debate público acerca da questão da justiça criminal e dos direitos humanos através das redes sociais (twitter, instagram e whatsapp) e do site
        <a href="https://www.covidnasprisoes.com/infovirus" target="_blank">
          https://www.covidnasprisoes.com/infovirus</a
        >. <br /><br />
        Em 2021, com apoio do Fundo Brasil de Direitos Humanos, iniciamos a
        construção do Memorial Covid² [pandemia nas prisões_] que tem como
        objetivo evidenciar a promoção da morte nos cárceres brasileiros através
        de dados circunstanciados produzidos pelo Infovírus e por outras
        organizações sociais comprometidas com a promoção dos direitos humanos.
        <br /><br />
        Com o mesmo intuito, conduzimos a pesquisa “Gestão da morte nas prisões e a pandemia da Covid-19”. A partir da análise dos processos de pessoas privadas de liberdade que morreram por contaminação pela covid-19, produzimos um relatório que pode ser acessado <a href="https://drive.google.com/file/d/1QKiLAMKHhnQAga50sgO2BolSJKZQsRIH/view?usp=drivesdk " target="_blank">aqui.</a>
      </p>
    </div>

    <div class="l-700 text-red" data-aos="fade-down">
      "Coronavírus não é Habeas Corpus"
    </div>
    <p class="mt-5 text text-justify" data-aos="fade-down">
      <video
        autoplay
        loop
        class="img-moro"
        src="@/assets/images/gif-moro.mp4"
      ></video>
      <br />
      <br />
      / / /
      <br />
      <br />
      Ao invés de concessão de liberdade e prisão domiciliar: mais restrição,
      maus tratos e tortura. Ao invés de garantia de comunicação sobre a saúde
      das pessoas presas: mais incomunicabilidade com as famílias e
      transferências em segredo de pessoas presas entre unidades prisionais. Ao
      invés de melhores condições estruturais das prisões: propostas de uso de
      containers como forma de aprisionamento. Ao invés de garantia à vida: o
      aprofundamento da exposição das pessoas privadas de liberdade ao
      coronavírus e à morte.
    </p>
    <scroll-observer
      @start="playAnimation"
      sentinalName="obbx"
    ></scroll-observer>

    <div class="section-horizontal mt-5 mb-5 pb-4 nucleo01scroll1">
      <div class="horizontal-content">
        <div class="horizontal horizontal-1">
          <div class="data mb-2">
            <NumberCounter :from="1" :to="10" isZero></NumberCounter
            >/<NumberCounter :from="1" :to="4" isZero></NumberCounter
            >/<NumberCounter :from="1966" :to="2020" isZero></NumberCounter>
          </div>
          <div class="text mb-3">
            Primeira morte de presos pela Covid-19 é registrada no Rio de
            Janeiro.
            <div>
              <a
                class="link-fonte"
                href="https://ponte.org/primeira-morte-de-preso-pela-covid-19-no-brasil-e-registrada-no-rj/"
                target="_blank"
                ><i class="bi bi-link-45deg"></i><span>Notícia</span></a
              >
            </div>
          </div>
          <!-- <iframe src="https://www.google.com/maps/d/embed?mid=12H-ndGSfkNurCZ5E6Khf62UWK9T1U2KY&hl=pt-BR&ehbc=2E312F" width="640" height="480"></iframe> -->
          <a
            class="link-mapp"
            target="_blank"
            href="https://www.google.com/maps/d/u/0/viewer?hl=pt-BR&mid=12H-ndGSfkNurCZ5E6Khf62UWK9T1U2KY&ll=-15.687207194074333%2C-53.740310799999996&z=4"
          >
            <!-- <scroll-observer
              @start="exibirMapa"
              sentinalName="mapaaaa"
            ></scroll-observer> -->
            <img src="@/assets/images/mapa-1.png" alt="mapa brasil" />
            <img
              v-if="showMancha"
              class="mancha-brasil"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
            <img
              v-if="showMancha"
              class="mancha-brasil-1"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
            <img
              v-if="showMancha"
              class="mancha-brasil-2"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
            <img
              v-if="showMancha"
              class="mancha-brasil-3"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
            <img
              v-if="showMancha"
              class="mancha-brasil-4"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
            <img
              v-if="showMancha"
              class="mancha-brasil-5"
              src="@/assets/images/sangue.webp"
              alt="mapa brasil"
            />
          </a>
          <div class="clic">
            Clique no mapa para visualizar a lista de presídios
          </div>
        </div>
        <div class="seta mx-5"></div>
        <div class="horizontal horizontal-2">
          <div class="text">
            O intervalo entre o primeiro contágio e a primeira morte, em
            presídios foi de
          </div>
          <div class="numeracao mb-5">
            <NumberCounter :from="1" :to="9"></NumberCounter>
            dias
          </div>
          <div class="text">Enquanto na população geral foi de</div>
          <div class="numeracao">
            <NumberCounter :from="1" :to="20"></NumberCounter> dias
          </div>
          <a
            class="link-fonte"
            href="https://www1.folha.uol.com.br/cotidiano/2020/05/letalidade-do-coronavirus-entre-presos-brasileiros-e-o-quintuplo-da-registrada-na-populacao-geral.shtml"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="line"></div>
        <div class="horizontal horizontal-3">
          <div class="text mb-3" id="nucleo01scroll1">
            A taxa de letalidade foi de
          </div>
          <div class="numeracao">
            <NumberCounter :from="1" :to="5"></NumberCounter>%
          </div>
          <div class="text mb-5">entre pessoas presas e</div>
          <div class="numeracao">
            0,<NumberCounter :from="1" :to="96"></NumberCounter>%
          </div>
          <div class="text mb-5">na população em geral</div>
          <a
            class="link-fonte"
            href="https://www1.folha.uol.com.br/cotidiano/2020/05/letalidade-do-coronavirus-entre-presos-brasileiros-e-o-quintuplo-da-registrada-na-populacao-geral.shtml"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="line"></div>
        <div class="horizontal horizontal-4">
          <div class="text">
            Até março de 2022, foram oficialmente registrados
          </div>
          <div class="numeracao">
            <NumberCounter :from="1" :to="108358" :duration="3"></NumberCounter>
          </div>
          <div class="text">casos de Covid-19 nas prisões</div>
          <div class="text">sendo</div>
          <div class="numeracao">
            <NumberCounter :from="0" :to="75337" :duration="3"></NumberCounter>
          </div>
          <span class="text">pessoas presas e </span>
          <div class="numeracao">
            <NumberCounter :from="0" :to="33021" :duration="3"></NumberCounter>
          </div>
          <div class="text">servidores.</div>
          <br/>
          <a
            class="link-fonte"
            href="https://www.cnj.jus.br/wp-content/uploads/2022/04/boletim-covid-19-marco2022.pdf"
            target="_blank"
            ><i class="bi bi-link-45deg"></i><span>Fonte</span></a
          >
        </div>
        <div class="line"></div>
        <div
          class="
            horizontal horizontal-5
            mr-5
            d-flex
            align-items-center
            justify-content-center
          "
        >
          <div class="text mr-5">
            “Um grande contágio no sistema prisional e socioeducativo faria com
            que todos os doentes morressem sem atendimento”, diz Ariel de Castro
            Alves, advogado especialista em direitos da infância e juventude. “A
            própria sociedade não aceitaria que eles ocupassem espaços nos
            hospitais no lugar de quem nunca teve envolvimento criminal.”
          </div>
        </div>
      </div>
    </div>
    <div class="arraste-section" @click="scrollRight()">
      Arraste para o lado <i class="bi bi-chevron-double-right seta"></i>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import audios from "@/mixins/audios.js";
import ScrollObserver from "@/components/ScrollObserver.vue";
export default {
  components: { ScrollObserver },
  data() {
    return {
      showMancha: false,
    };
  },
  mixins: [audios],
  methods: {
    scrollRight() {
      let content = document.querySelector(".nucleo01scroll1");
      content.scrollLeft += 300;
    },
    playAnimation() {
      this.showMancha = false;
      setTimeout(() => {
        this.showMancha = true;
      }, 100);
    },
  },
};
</script>


<style lang="scss" scoped>
.text-red {
  margin-top: 60px;
  background-color: #d01c1f;
  color: white;
  font-family: Roboto Mono;
  padding: 2px 2px 0px 2px;
  font-size: 1.5rem;
  font-weight: 300;
}

.exposicao-musica {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: white;

  .item {
    cursor: pointer;
    background-color: #dc793bd2;
    border-radius: 7px;
    padding: 10px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 5px;
  }

  .icon {
    font-size: 32px;
  }
  .text {
    padding: 0 0px;
  }
}

.link-mapp {
  position: relative;
}

.img-moro {
  width: 700px;
}

.horizontal-content {
  color: #d01c1f;
  font-size: 1.1rem;
  font-family: Roboto Condensed;
  font-weight: 300;
  padding: 30px;
  display: flex;
  width: fit-content;
}

.seta {
  color: #626262;
}

.clic {
  color: #626262;
  margin-top: 10px;
  text-align: center;
  font-size: 0.8rem;
}

.line {
  width: 1px;
  background-color: #626262a2;
  height: 400px;
  margin: 0 55px;
}

.horizontal {
  position: relative;
  .data {
    font-size: 3rem;
    font-family: Roboto Mono;
    font-weight: 100;
  }
  .text {
    width: 260px;
    line-height: 1.1rem;

    &.big {
      font-size: 3rem;
      line-height: 3.1rem;
      font-family: Roboto Mono;
      color: #626262;
      font-weight: 100;
    }
  }
  img {
    width: 260px;
  }
  .numeracao {
    font-family: Roboto Mono;
    font-weight: 100;
    font-size: 3.3rem;
  }
}

.mancha-brasil {
  position: absolute;
  width: 80px !important;
  top: 30px;
  left: 160px;
  opacity: 0;
  transform: scale(2);
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 0.5s;
  animation-timing-function: ease-in-out;
}

.mancha-brasil-1 {
  position: absolute;
  width: 80px !important;
  top: 68px;
  left: 96px;
  opacity: 0;
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 2s;
  animation-timing-function: ease-in-out;
}
.mancha-brasil-2 {
  position: absolute;
  width: 80px !important;
  top: -102px;
  left: 90px;
  opacity: 0;
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 4s;
  animation-timing-function: ease-in-out;
}
.mancha-brasil-3 {
  position: absolute;
  width: 80px !important;
  top: -28px;
  left: 91px;
  opacity: 0;
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 6s;
  animation-timing-function: ease-in-out;
}
.mancha-brasil-4 {
  position: absolute;
  width: 80px !important;
  top: -74px;
  left: 184px;
  opacity: 0;
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 8s;
  animation-timing-function: ease-in-out;
}
.mancha-brasil-5 {
  position: absolute;
  width: 80px !important;
  top: -83px;
  left: 14px;
  opacity: 0;
  animation-duration: 6s;
  animation-name: scaleIn;
  animation-fill-mode: forwards;
  animation-delay: 10s;
  animation-timing-function: ease-in-out;
}
*::-webkit-scrollbar {
  width: 3px;
  height: 12px;
}

*::-webkit-scrollbar-track {
  background: #e4e4e4;
}

*::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 8px;
}

@media screen and (max-width: 480px) {
  .img-moro {
    width: 100%;
  }
}

@keyframes scaleIn {
  from {
    opacity: 0;
    transform: scale(0);
  }

  to {
    opacity: 1;
    transform: scale(1.5);
  }
}
</style>